import React from "react";
import { SpectralProvider } from "@spectral-finance/spectral-modal";
import Score from "./Score";

function App() {
  return (
    <SpectralProvider
      logo={"https://i.ibb.co/m99K3GP/download.png"}
      partnerId={"1fb1e7f3-feee-4318-ab0d-21ddbc39610d"}
    >
      <Score />
    </SpectralProvider>
  );
}

export default App;
